import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsButtonInvertiertEnergieV1(props: SVGProps<SVGSVGElement>) {
  return <svg
    data-name="Ebene 1"
    viewBox="0 0 27.12 43"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.01 42.86c-1.12 0-2.17-.49-2.9-1.36a3.934 3.934 0 0 1-.86-3.11c0-.06.02-.11.04-.17l3.05-10.39-4.04 1.69c-.06.03-.13.05-.19.06-1.67.4-3.46-.41-4.29-1.93-.67-1.22-.64-2.72.06-3.92L13.39 2.04c.74-1.22 1.94-1.9 3.26-1.9 1.2 0 2.33.58 3.05 1.55.65.88.89 2.01.66 3.08L16.8 16.95l4.95-1.72s.1-.03.14-.04c1.58-.35 3.26.41 4.07 1.82.67 1.16.69 2.62.04 3.8-.01.02-.06.12-.08.14l-6.86 10.63c-.37.58-1.15.75-1.73.37-.58-.37-.75-1.15-.37-1.73l6.82-10.56c.26-.48.26-1 .02-1.41-.27-.47-.8-.72-1.31-.64l-7.16 2.49c-.44.15-.93.05-1.27-.27-.34-.32-.47-.81-.34-1.26l4.22-14.41c.06-.29-.03-.69-.25-1-.51-.7-1.65-.66-2.11.09L3.04 25c-.27.45-.28 1.01-.03 1.47.28.52.86.81 1.43.71l6.36-2.66a1.253 1.253 0 0 1 1.69 1.5L8.73 38.83c-.04.39.07.77.31 1.05.54.65 1.64.56 2.08-.17l3.03-4.68c.38-.58 1.15-.74 1.73-.37.58.38.75 1.15.37 1.73l-3.01 4.65a3.8 3.8 0 0 1-3.21 1.8Z"
      style={{
        fill: '#fff',
      }}
    />
  </svg>
}
export default SvgMsKlimadashboardIconsButtonInvertiertEnergieV1
